var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
        {
            'open': _vm.accordionOpen,
        },
        `
            accordion-item
        `
    ],on:{"click":_vm.toggleAccordion}},[_c('div',{staticClass:"accordion-tab"},[_c('i',{class:[
            _vm.accordionOpen ? 'fa-minus' : 'fa-plus', 
            `
                accordion-icon fas
            `
            ]}),_vm._v(" "),_c('span',{staticClass:"accordion-title",domProps:{"innerHTML":_vm._s(_vm.title)}})]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.accordionOpen)?_c('div',{staticClass:"accordion-inner"},[_vm._t("default")],2):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }